exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2GMnf{-webkit-box-shadow:none;box-shadow:none}._2GMnf,._3x2Nt{background:none;border:0}._5wvcj{padding:0;border:0}._1nsHR,._1nsHR:active,._1nsHR:focus,._1nsHR:hover{width:100%;color:#646464;font-size:16px;font-size:1rem;background:none;-webkit-box-shadow:none;box-shadow:none;white-space:normal;border:1px solid #a9a9a9}._31Gym [class^=panel]>div button{margin-top:0}", ""]);

// exports
exports.locals = {
	"panel": "_2GMnf",
	"panelHeading": "_3x2Nt",
	"panelBody": "_5wvcj",
	"toggleButton": "_1nsHR",
	"collapsibleDetails": "_31Gym"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"minimize":true,"discardComments":{"removeAll":true},"localIdentName":"[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/components/Collapsible/Collapsible.scss
// module id = 772
// module chunks = 2